import React from 'react';
import { Button, ButtonGroup } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';
import {
  DeleteModal,
  getCurrentUserHook,
  getTranslatedText
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

const TimesheetActionCell = (props) => {
  const intl = useIntl();
  const user = getCurrentUserHook();
  const { cell } = props;
  const { timerId, technician, workItem } = cell.row?.original;

  return technician?.userId === user?.userId && workItem?.workId ? (
    <div className="action-button">
      <ButtonGroup>
        <DeleteModal
          modalActivator={
            <Button
              icon={
                <div id="delete-modal">
                  <SVGIcon name="Delete" color="#EC9E9E" />
                </div>
              }
            />
          }
          title={getTranslatedText(intl, 'timer.unknown.delete.title')}
          handleDeleteConfirmation={() => {
            cell.column?.actions?.deleteWorklogTimerEntry({
              variables: {
                deleteWorklogTimerInput: {
                  timerId: timerId
                }
              }
            });
          }}
          description={getTranslatedText(
            intl,
            'timer.unknown.delete.description'
          )}
        />
      </ButtonGroup>
    </div>
  ) : null;
};

export default TimesheetActionCell;
